<template>
  <div class="document">
    <div class="header">
      <EsHeader>
        <template #header>
          Automatic File Processing
        </template>
        <template #actions v-if="hasModule('SYS:SYS:CONFIGMGR:EDIT')">
          <ul>
            <li class="p-narrow no-border">
              <div class="list-content">
                <a role="button" tabindex="0"
                  @keyup.enter="editPanel()"
                  @click="editPanel()"
                  :class="{ disabled: editOtherPanels }"
                  v-if="!editCurrentPanel"
                  title="Edit"
                >
                  <font-awesome-icon :icon="['far', 'edit']" size="lg"/>
                </a>
              </div>
            </li>
          </ul>
        </template>
      </EsHeader>
    </div>
    <div class="content">
      <es-form style="padding: 1.15rem 0rem; margin: 0">
        <template #es-form>
          <table>
            <tbody>
              <tr>
                <th class="table-header-normal property has-text-grey"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  AFP Processing
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <div
                      class="buttons has-addons"
                      v-if="editCurrentPanel"
                    >
                      <button
                        class="button button--form"
                        v-for="(option, index) in enabledDisabled"
                        :key="index"
                        @click="selectedType(form.AFP_ENABLED  = option.code)"
                        :class="{ 'is-active': form.AFP_ENABLED === option.code }"
                      >
                        {{ option.description }}
                      </button>
                    </div>
                    <input
                      v-else
                      class="input has-text-right is-pulled-right"
                      :class="{ 'is-static': !editCurrentPanel }"
                      type="text"
                      v-model="form.AFP_ENABLED === true ? 'Enabled' : 'Disabled'"
                      :readonly="!editCurrentPanel"
                      aria-label="AFP Processing"
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <th
                  class="table-header-normal property has-text-grey"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  AFP Folder
                  <span v-if="editCurrentPanel  && !form.AFP_ENABLED">
                    (optional)
                  </span>
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      class="input has-text-right is-pulled-right"
                      :class="{ 'is-static': !editCurrentPanel, 'is-danger' : hasErrorAFPFolder }"
                      @keyup.prevent="validateField(form.AFP_FOLDER)"
                      :readonly="!editCurrentPanel"
                      type="text"
                      :disabled="!form.AFP_ENABLED"
                      v-model="form.AFP_FOLDER"
                      aria-label="AFP Folder"
                    >
                  </div>
                  <span v-if="hasErrorAFPFolder" class="help is-danger">
                    {{ msgAFPFolder }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </es-form>
    </div>
    <div
      v-if="editCurrentPanel"
      class="is-flex flex-justify--end flex-align--center"
      style="margin-right: 2rem; padding-bottom: 2rem"
    >
      <button
        class="button button-link has-underline"
        @click.prevent="cancelPanel()"
        style="margin-right: 1rem"
      >
        Cancel
      </button>
      <button
        class="button is-primary"
        @click.prevent="updatePanel()"
      >
        Update
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsForm,
    EsHeader,
  },
  props: {
    editOtherPanels: {
      type: Boolean,
    },
  },
  data() {
    return this.initialData();
  },
  created() {
    this.enabledDisabled = [
      {
        code: true,
        description: 'Enabled',
      },
      {
        code: false,
        description: 'Disabled',
      },
    ];
  },
  mounted() {
    this.initialize(this.properties);
    this.updateCache();
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
  },
  methods: {
    ...mapActions({
      initProperties: 'propertiesModule/init',
    }),
    cancelPanel() {
      this.undoForm();
      this.resetFormErrors();
      this.hideNotification();
      this.editCurrentPanel = false;
      this.$emit('allowEditOtherPanels');
    },
    checkForFormChanges() {
      return this.compareObjects(this.cache, this.form);
    },
    compareObjects(o, n) {
      return JSON.stringify(o) !== JSON.stringify(n);
    },
    editPanel() {
      this.editCurrentPanel = true;
      this.$emit('allowEditOtherPanels');
    },
    groupBySection(data, type) {
      return Object.entries(data)
        .filter(([key]) => key.includes(type))
        .map(([key, val]) => ({ [key.replace(type, '')]: val }));
    },
    initialData() {
      return {
        cache: {},
        form: {},
        editCurrentPanel: false,
        hasErrorAFPFolder: false,
        msgAFPFolder: null,
      };
    },
    initialize(data) {
      this.form = this.prepForDisplay('form', this.groupBySection(data, 'AFP-'));
      this.form.AFP_ENABLED  = JSON.parse(this.form.AFP_ENABLED);
    },
    prepForDisplay(type, arrFromDb) {
      const o = {};
      arrFromDb.map((item) => {
        const key = Object.keys(item)[0];
        const value = item[key];
        o[key] = value;
        return 0;
      });
      return o;
    },
    prepForRequest() {
      const payload = [];
      let cached = null;
      let obj = null;
      obj = this.form;
      cached = this.cache;
      this.pushToPayLoad('AFP', payload, obj, cached);
      return payload;
    },
    pushToPayLoad(category, payload, obj, cached) {
      Object.entries(obj).forEach(([property, value]) => {
        if (value !== cached[property]) {
          payload.push({ category, property, value });
        }
      });
    },
    resetFormErrors() {
      this.hasErrorAFPFolder = false;
      this.msgAFPFolder= null;
    },
    selectedType(option) {
      if (option === false) {
        this.undoForm();
        this.resetFormErrors();
        this.hideNotification();
        this.form.AFP_ENABLED = false;
      }
    },
    showFormErrors(errors) {
      errors.forEach((e) => {
        if (e.property === 'AFP_FOLDER') {
          this.hasErrorAFPFolder = true;
          this.msgAFPFolder= e.error;
        }
      });
    },
    undoForm() {
      this.form = JSON.parse(JSON.stringify(this.cache));
    },
    updateCache() {
      this.cache = JSON.parse(JSON.stringify(this.form));
    },
    async updatePanel() {
      this.$emit('allowEditOtherPanels');
      const changes = this.checkForFormChanges();
      if (!changes) {
        this.editCurrentPanel = false;
        this.hideNotification();
        return;
      }
      try {
        await axios({
          method: 'put',
          url: '/properties',
          data: this.prepForRequest(),
        });
        this.updateCache();
        await this.initProperties();
        this.showNotification('success', ['The Automatic File Processing have been updated successfully.']);
        this.editCurrentPanel = false;
      } catch (error) {
        if (error.response.status === 400) {
          this.$emit('allowEditOtherPanels');
          this.showFormErrors(error.response.data);
          this.apiMsg = 'There was an issue. Please try again or contact your administrator.';
        } else {
          this.apiMsg = 'There were some errors. Please fix the errors highlighted in the fields below.';
        }
        this.showNotification('danger', [this.apiMsg]);
      }
    },
    validateField(field) {
      if (field === this.form.AFP_FOLDER) {
        if (this.form.AFP_ENABLED && !this.form.AFP_FOLDER) {
          this.hasErrorAFPFolder = true;
          this.msgAFPFolder = 'AFP Folder is required.';
        } else {
          this.hasErrorAFPFolder = false;
          this.msgAFPFolder = null;
        }
      }
    }
  },
};
</script>

<style lang="sass" scoped>
  table th
    vertical-align: middle
  table td
    vertical-align: middle
  a.disabled
    color: #999
    cursor: default
    text-decoration: none
    pointer-events: none
    &:hover
      text-decoration: none
  .property
    padding-left: 0
    font-size: 12px
    width: 48%
  .no-border
    border: 0
  .buttons
    float: right
</style>
